export enum Actions {
  AddFactory = 'Add Factory',
  DeleteFactory = 'Delete Factory',
  ReplaceFactory = 'Replace Factory',
}
